const apiUrl = import.meta.env.VITE_BASE_URL;

export const server = apiUrl;

export const backend_url = import.meta.env.VITE_BACKEND_URL;

export const backend_url_local = import.meta.env.VITE_BACKEND_URL_LOCAL;
